import { getPlaceData } from '@pcln/build-shop-search-form'
import { formatDate } from './date-helper'

const getComponentsFromTripType = (tripType: string, option: any) => {
  let index = 0

  const addProductToComponents = (
    productItem: any,
    components: unknown[],
    shouldUnshift?: boolean
  ) => {
    const updatedComponents = [...components]

    if (shouldUnshift) {
      updatedComponents.unshift(productItem)
    } else {
      updatedComponents.push(productItem)
    }
    index += 1
    return updatedComponents
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const addHotelToComponents = (components: unknown[], option: any) => {
    const productItem = {
      productId: 5,
      index,
      type: 'STAY',
      query: {
        totalNumRooms: option.roomCount,
        ...(option.hotelLocation ? { destination: option.hotelLocation } : {}),
        ...(option.isPartialStayDateValid
          ? {
              travelStartDate: {
                value: option.hotelStartDate
              },
              travelEndDate: {
                value: option.hotelEndDate
              }
            }
          : {})
      }
    }

    return addProductToComponents(productItem, components, true)
  }

  const addFlightToComponents = (components: unknown[]) => {
    const productItem = {
      productId: 1,
      index,
      type: 'FLY',
      query: {
        includeBasicEconomy: option.includeBasicEconomy
      }
    }

    return addProductToComponents(productItem, components)
  }

  const getRCPlaceData = (carLocation: any) => ({
    ...getPlaceData(carLocation),
    cityName: carLocation.cityName,
    lat: carLocation.lat,
    lon: carLocation.lon,
    stateCode: carLocation.stateCode,
    postalCode: carLocation.postalCode,
    addressLine1: carLocation.addressLine1
  })

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const addCarToComponents = (components: unknown[], option: any) => {
    const productItem = {
      productId: 8,
      type: 'DRIVE',
      index,
      ...(option.isCarRequired ? {} : { isRequired: false })
    }

    if (
      option.pickupCarSomewhere &&
      option.rcPickupDate &&
      option.rcDropoffDate &&
      option.rcLocation
    ) {
      const productItemWithQuery = {
        ...productItem,
        query: {
          pickupDateTime: `${formatDate(option.rcPickupDate, 'yyyy-MM-dd')}T${
            option.rcPickupTime as string
          }`,
          returnDateTime: `${formatDate(option.rcDropoffDate, 'yyyy-MM-dd')}T${
            option.rcDropoffTime as string
          }`,

          pickupLocation: getRCPlaceData(option.rcLocation),
          returnLocation: getRCPlaceData(option.rcLocation),
          isIncludeAirportLocations: option.pickupCarIncludeAirport
        }
      }

      return addProductToComponents(productItemWithQuery, components)
    }

    return addProductToComponents(productItem, components)
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const mapComponent = (components: unknown[], type: string, option: any) => {
    switch (type) {
      case 'STAY':
        return addHotelToComponents(components, option)
      case 'FLY':
        return addFlightToComponents(components)
      case 'DRIVE':
        return addCarToComponents(components, option)
      default:
        return components
    }
  }

  return tripType
    .split(':')
    .reduce<unknown[]>(
      (components, type) => mapComponent(components, type, option),
      []
    )
}

export default getComponentsFromTripType
